import { bannerStyles } from "@insite/content-library/Widgets/Category/CategoryDetailBanner";
import { css } from "styled-components";

bannerStyles.container = {
    css: css`
        border-bottom: 2px solid #f0f0f0;
        margin-bottom: 20px;
        margin-top: -16px;
        font-size: 13px;
        color: #696969;
        font-weight: 600;
        p[class^="TypographyStyle"] {
            > span {
                font-size: 13px;
                color: #696969;
                font-weight: 600;
            }
        }
    `,
};
